import React from "react";
import "./styles/Footer.css";
import { AppRoutes } from "../common/app-routes";
import { APP_NAME } from "../common/constants";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-col brand">
          <div className="footer-brand-header">
            <img src="./favicon-32x32.ico" alt={`${APP_NAME} logo`} className="footer-logo" width={32} height={32}/>
            <h3>{APP_NAME}</h3>
          </div>
          <p>Build your app in minutes</p>
          <p>Copyright © 2025 - All rights reserved</p>
          <button className="footer-badge">Built with Fast App</button>
        </div>
        <div className="footer-col">
          <h4>Legal</h4>
          <ul>
            <li><a href={AppRoutes.TERMS_AND_CONDITIONS}>Terms of Service</a></li>
            <li><a href={AppRoutes.PRIVACY_POLICY}>Privacy Policy</a></li>
            <li><a href={AppRoutes.LICENSE}>Licenses</a></li>
          </ul>
        </div>
        {/* <div className="footer-col">
          <h4>Built with Fast App</h4>
          <h5>Coming soon</h5>
        </div> */}
        <div className="footer-col">
          <h4>Support</h4>
          <p>Contact support@cutora.io</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
